import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAtmedHealthFeedBack,
} from '../../../store/actions';
import FeedBack from './Feedback';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  allHomeFeedback: vendorEquipmenReducer.allHomeFeedback,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAtmedHealthFeedBack,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack);
